import React from 'react';
import { Route, Routes } from 'react-router-dom';
import FinancialsMainLanding from '../modules/finance/pages/FinancialsMainLanding';
import FinanceLanding from '../modules/finance/pages/FinanceLanding';
import Invoices from '../modules/finance/pages/Invoices';
import InvoiceDetail from '../modules/finance/pages/InvoiceDetail';
import Payments from '../modules/finance/pages/Payments';
import Proformas from '../modules/finance/pages/Proformas';
import ProformaDetail from '../modules/finance/pages/ProformaDetail';

const FinanceRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<FinancialsMainLanding />} />
      <Route path="finance-setup" element={<FinanceLanding />} />
      <Route path="setup" element={<FinanceLanding />} />
      <Route path="invoices" element={<Invoices />} />
      <Route path="invoices/:id" element={<InvoiceDetail />} />
      <Route path="payments" element={<Payments />} />
      <Route path="proformas" element={<Proformas />} />
      <Route path="proformas/:id" element={<ProformaDetail />} />
    </Routes>
  );
};

export default FinanceRoutes;
